/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import {UserAvatar} from '../../../../app/components/UserAvatar'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  
  const getNombreCompleto = (): string => {
    if (currentUser?.nombre && currentUser?.apellido) {
      return `${currentUser.apellido}, ${currentUser.nombre}`
    }
    if (currentUser?.nombre) return currentUser.nombre
    return ''
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <UserAvatar
            firstName={currentUser?.nombre ?? currentUser?.first_name}
            lastName={currentUser?.apellido ?? currentUser?.last_name}
            email={currentUser?.email}
            size='md'
            className='me-5'
          />

          <div className='d-flex flex-column' style={{minWidth: 0, flex: 1}}>
            <div
              className='fw-bolder fs-5'
              style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
              title={currentUser?.email}
            >
              {currentUser?.email}
            </div>
            {getNombreCompleto() && (
              <span className='text-muted fs-7' style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 400}}>
                {getNombreCompleto()}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Salir
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
